import { style } from "@vanilla-extract/css";
import { vars } from "../../styles/theme.css";

export const tableStyles = style({
  width: "100%",
  borderCollapse: "collapse",
  whiteSpace: "nowrap",
});

export const columnStyles = style({
  padding: vars.space.xs,
  textAlign: "start",
  fontFamily: vars.fonts.bold,
});

export const endAlignedColumn = style([columnStyles, { textAlign: "end" }]);

export const centerAlignedColumn = style([
  columnStyles,
  { textAlign: "center" },
]);

export const rowStyles = style({
  borderBottom: vars.borders.outlineVariant,
});

export const cellStyles = style({
  padding: `${vars.space.m} ${vars.space.xs}`,
  textAlign: "start",
});

export const endAlignedCell = style([cellStyles, { textAlign: "end" }]);

export const centerAlignedCell = style([cellStyles, { textAlign: "center" }]);

export const stickyCellStyles = style([
  cellStyles,
  {
    position: "sticky",
    zIndex: vars.zIndex.table.stickyCol,
    left: 0,
    backgroundColor: vars.colors.surface,
  },
]);

export const stickyColumnStyles = style([
  columnStyles,
  {
    position: "sticky",
    zIndex: vars.zIndex.table.stickyHead,
    left: 0,
    backgroundColor: vars.colors.surface,
  },
]);

export const stickyHeaderCell = style({
  position: "sticky",
  zIndex: vars.zIndex.table.stickyHead,
  top: 0,
  backgroundColor: vars.colors.surface,
});
